<template>
    <div class="maintenance-wrapper">
        <div class="container">
            <div class="mt-header">
                <img src="../../assets/img/login-side_bg.png" alt="">
            </div>
            <div class="mt-body">
                <div class="hd text-center">
                    系统升级维护中
                </div>
                <div class="bd">
                    <p class="text-no-indent">尊敬的客户您好：</p>
                    <p>为了给您带来更好的体验，金穗智管平台于2020年7月10日19:30-22:00进行系统升级维护，在此期间无法为您提供服务，由此带来的不便敬请谅解，感谢您的理解和支持。</p>
                    <p>咨询请拨打电话：022-23256368</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Maintenance'
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/var";
    @import "../../assets/style/common";
    .maintenance-wrapper {
        height: 100%;
        background-color: #fff;
        position: relative;
    }
    .container {
        width: 960px;
        position: absolute;
        top: calc(50% - 380px);
        left: calc(50% - 480px);
    }
    .mt-header {
        text-align: center;
        margin-bottom: 40px;
        img  {
            width: 340px;
        }
    }
    .mt-body {
        .hd {
            font-size: 38px;
            font-weight: bold;
            margin-bottom: 40px;
        }
        .bd {
            font-size: 24px;
            line-height: 1.5;
            font-weight: bold;
            p {
                text-indent: 2em;
                margin-bottom: 10px;
                &.text-no-indent {
                    text-indent: 0;
                }
            }
        }
    }
</style>
